import Tech from './Tech/Tech';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';

import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Tech/>
      <Footer/>
    </div>
  );
}



export default App;
